import { createSlice } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  subUsers: [],
  selectedUser: null,
};

const reportSlice = createSlice({
  name: "reports",
  initialState: INITIAL_STATE,
  reducers: {
    loadSubUsers: (state, { payload }) => {
      state.subUsers = payload;
    },
    setSelectedUser: (state, { payload }) => {
      state.selectedUser = payload;
    },
  },
});

export const reportsReducer = reportSlice.reducer;

// Actions
export const { loadSubUsers, setSelectedUser } = reportSlice.actions;

export default reportSlice;
